module.exports = __webpack_public_path__ + "static/img/team-pic4.5f5a66ee.png";